import { observer } from "mobx-react-lite";
import React from "react";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import { translateGeneral } from "utils/localizations";
import FilterView from "../../common/filter";
import type AccountingDocumentsApprovalsViewModel from "viewModels/finance/accountingDocumentsApprovals/accountingDocumentsApprovalsViewModel";
import AdvancedInput, { Transformation } from "@edaz/edazkit/controls/AdvancedInput";
import DateRangeInputControl from "controls/dateRangeInput";
import NumberRangeInputControl from "controls/numberRangeInput";
import AdvancedSelect from "@edaz/edazkit/controls/AdvancedSelect";

export interface AccountingDocumentsApprovalsFiltersProps {
  vm: AccountingDocumentsApprovalsViewModel;
}

const AccountingDocumentsApprovalsFilters = observer((props: AccountingDocumentsApprovalsFiltersProps) => {
  const { vm } = props;

  return (
    <FilterView vm={vm}>
      <div className="row">
        <Form.Group as={Col} md={6} lg={4} xl={4}>
          <Form.Label>{vm.translateFilterAttribute("accountingDate")}</Form.Label>
          <DateRangeInputControl target={vm.filter} property="accountingDate" disabled={!!vm.filter.accountingPeriod} />
        </Form.Group>
        <Form.Group as={Col} md={6} lg={4} xl={2}>
          <Form.Label>{vm.translateFilterAttribute("accountingPeriod")}</Form.Label>
          <AdvancedSelect
            target={vm.filter}
            property="accountingPeriod"
            disabled={!!vm.filter.accountingDate?.from || !!vm.filter.accountingDate?.to}
            placeholder={translateGeneral("search")}
            allowEmpty={true}
            items={vm.accountingPeriodOptions}
          />
        </Form.Group>
        <Form.Group as={Col} md={6} lg={4} xl={2}>
          <Form.Label>{vm.translateFilterAttribute("sequenceName")}</Form.Label>
          <AdvancedInput transformation={Transformation.UpperCased} target={vm.filter} property="sequenceName" />
        </Form.Group>
        <Form.Group as={Col} md={6} lg={4} xl={4}>
          <Form.Label>{vm.translateFilterAttribute("accountingTemplateId")}</Form.Label>
          <AdvancedSelect target={vm.filter} property="accountingTemplateId" items={vm.accountingTemplatesOptions} />
        </Form.Group>
        <Form.Group as={Col} md={6} lg={4} xl={4}>
          <Form.Label>{vm.translateFilterAttribute("creditSum")}</Form.Label>
          <NumberRangeInputControl target={vm.filter} property="creditSum" />
        </Form.Group>
        <Form.Group as={Col} md={6} lg={4} xl={4}>
          <Form.Label>{vm.translateFilterAttribute("debitSum")}</Form.Label>
          <NumberRangeInputControl target={vm.filter} property="debitSum" />
        </Form.Group>
        <Form.Group as={Col} md={6} lg={4} xl={4}>
          <Form.Label>{vm.translateFilterAttribute("approvedBy")}</Form.Label>
          <AdvancedSelect
            target={vm}
            property="_approvalState"
            items={vm.approvalOptions}
            allowEmpty={true}
            placeholder={translateGeneral("select")}
          />
        </Form.Group>
      </div>
    </FilterView>
  );
});

export default AccountingDocumentsApprovalsFilters;
